import React from "react";
import icoInfoOrange from "../../../../assets/images/ico-info-orange.svg";
import carWarningImg from "../../../../assets/images/keyless-return/car-warning.svg";

export function WarningContent({t}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        gap: "16px",
      }}
    >
      <img src={carWarningImg} alt="Aviso veículo" className="return-image" />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          border: "1px solid #E0E0E0",
          borderRadius: "8px",
          padding: "12px 16px",
          width: "100%",
          boxSizing: "border-box",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        }}
      >
        <img
          src={icoInfoOrange}
          alt="Ícone aviso"
          style={{ width: "16px", height: "16px", flexShrink: 0 }}
        />
        <span
          style={{
            fontSize: "12px",
            color: "#333",
            textAlign: "left",
            fontWeight: "bold",
            lineHeight: "1.3",
          }}
        >
          {t("keylessReturnDivergence")}
        </span>
      </div>

      <p
        style={{
          fontSize: "13px",
          color: "#333",
          margin: 0,
          lineHeight: "1.4",
        }}
      >
        {t("keylessReturnExtraCharges")}
        <br />
        <strong>
          {t("keylessReturnCreditCard")}
        </strong>
      </p>
    </div>
  );
}
